import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '../../stores/auth.store';

export const Route = createFileRoute('/config/')({
  beforeLoad: () => {
    const { user, permissions } = useAuthStore.getState();
    if (!user) throw redirect({ to: '/login' });
    if (!permissions.includes('config:view')) throw redirect({ to: '/dashboard' });
    throw redirect({ to: '/config/request-types' });
  },
});
